//surveypage.tsx
import React, { useState } from "react";
import { Container } from "@mui/material";
import { CompanyCultureForm } from "./Survey/CompanyCultureForm";
import { LanguageSelection } from "./Survey/LanguageSelection";

const SurveyPage = () => {
  const [language, setLanguage] = useState<string | null>(null);
  return (
    <Container sx={{ bgcolor: "white", p: 0, py: 4 }}>
      {language ? (
        <CompanyCultureForm language={language} onLanguageChange={() => setLanguage(null)} />
      ) : (
        <LanguageSelection onLanguageSelect={setLanguage} />
      )}
    </Container>
  );
};

export default SurveyPage;
